export default __webpack_public_path__ + "static/yukimamiya-d011206e345d5698cab91cb2add86d6c.jpg";